import React from 'react';
import contactsData from '../data/contactsData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

function Contacts() {
    return (
        <section id="contact">
            <p class="anchor" id="contactos"></p>
            <div className="container wow fadeInUp">
                <div className="section-header">
                    <h3 className="section-title">Contactos</h3>
                    <p className="section-description">Pode contactar o Núcleo de Estudantes de Engenharia Química da FEUP através dos seguintes meios:</p>
                </div>
            </div>

            <div className="container wow fadeInUp mb-5">
                <div className="row justify-content-center info">
                    <div className="col-md-5">
                        <div className="contact-icon">
                            <FontAwesomeIcon icon={faLocationDot}/>
                            <p style={{textAlign: "left"}}>{contactsData[0].street}<br />{contactsData[0].postal}<br />{contactsData[0].building}</p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="contact-icon">
                            <FontAwesomeIcon icon={faEnvelope}/>
                            <p>{contactsData[0].email}</p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="contact-icon">
                            <FontAwesomeIcon icon={faPhone}/>
                            <p>{contactsData[0].phone}</p>
                        </div>
                    </div>
                </div>
            </div>

            <iframe
                title="map"
                src={contactsData[0].google_maps}
                width="100%" height="380" style={{border:"0", marginBottom: 0}} allowFullScreen />
            
        </section>
    );
}

export default Contacts;